import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Datenschutzerklärung" testid="privacy-page">
      <Section title="1. Verantwortlicher">
        <p>Verantwortlich für die Datenverarbeitung im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
        <p>
          Mathias Walch<br />
          Neufeldstraße 13<br />
          6890 Lustenau, Österreich<br />
          E-Mail: office@mw3d.at
        </p>
      </Section>

      <Section title="2. Welche Daten wir speichern">
        <p>Im Rahmen der Nutzung von SafeBuddy verarbeiten wir folgende Daten:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Kontodaten:</b> Vor- und Nachname, E-Mail-Adresse, verschlüsseltes Passwort.</li>
          <li><b>Kontaktdaten:</b> von dir hinterlegte Notfallkontakte (Name, Telefonnummer, Beziehung).</li>
          <li><b>NFC-Tag-/Profildaten:</b> Angaben, die du deinem SafeBuddy zuordnest (z. B. Name, medizinische Hinweise, Foto/Avatar).</li>
          <li><b>Bestell- und Lieferdaten:</b> bei Käufen im Shop Name, E-Mail, Lieferadresse, gewählte Produkte und Zahlungsstatus.</li>
          <li><b>Nutzungsdaten:</b> Ereignisse an einem Tag (z. B. Scan-Zeitpunkt, optional freiwillig geteilter Standort und Nachricht eines Finders).</li>
          <li><b>Technische Daten:</b> IP-Adresse, Zeitstempel und technisch notwendige Cookies (siehe Cookie-Richtlinie).</li>
        </ul>
      </Section>

      <Section title="3. Zweck und Rechtsgrundlagen">
        <p>Wir verarbeiten deine Daten zur Bereitstellung des Dienstes (Vertragserfüllung, Art. 6 Abs. 1 lit. b DSGVO), zur Erfüllung rechtlicher Pflichten (lit. c), sowie auf Grundlage berechtigter Interessen (lit. f) an einem sicheren, funktionierenden Dienst. Notfallrelevante Profildaten werden veröffentlicht bzw. für Finder sichtbar gemacht, weil dies der Kernzweck von SafeBuddy ist und du diese Daten bewusst hinterlegst (Einwilligung, lit. a).</p>
      </Section>

      <Section title="4. Weitergabe an Dritte">
        <p>Eine Weitergabe erfolgt nur, soweit es zur Diensterbringung erforderlich ist:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><b>PayPal</b> (PayPal (Europe) S.à r.l. et Cie, S.C.A.): Abwicklung von Zahlungen im Shop. Dabei werden zahlungsrelevante Daten an PayPal übermittelt.</li>
          <li><b>Resend</b> (E-Mail-Versanddienst): Versand von System- und Bestell-E-Mails (z. B. Aktivierungscodes, Passwort-Zurücksetzung).</li>
          <li><b>Hosting-/Infrastruktur-Dienstleister</b>: Betrieb der Anwendung und Speicherung der Daten.</li>
        </ul>
        <p>Mit allen Auftragsverarbeitern bestehen entsprechende Vereinbarungen gemäß Art. 28 DSGVO. Eine darüber hinausgehende Weitergabe oder ein Verkauf deiner Daten findet nicht statt.</p>
      </Section>

      <Section title="5. Speicherdauer">
        <p>Wir speichern personenbezogene Daten nur so lange, wie es für die genannten Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen (z. B. steuerrechtlich für Bestellungen) dies verlangen. Nach Löschung deines Kontos werden deine Daten entfernt, soweit keine Aufbewahrungspflicht besteht.</p>
      </Section>

      <Section title="6. Deine Rechte">
        <p>Dir stehen nach der DSGVO folgende Rechte zu: Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21). Eine erteilte Einwilligung kannst du jederzeit mit Wirkung für die Zukunft widerrufen.</p>
        <p>Zur Ausübung deiner Rechte – insbesondere Auskunft und Löschung – genügt eine formlose Nachricht an office@mw3d.at. Zudem hast du das Recht auf Beschwerde bei einer Datenschutz-Aufsichtsbehörde (in Österreich: Datenschutzbehörde, in Deutschland: die jeweils zuständige Landesbehörde).</p>
      </Section>

      <Section title="7. Kontakt">
        <p>Bei Fragen zum Datenschutz erreichst du uns unter office@mw3d.at. Die vollständigen Anbieterangaben findest du im <a href="/imprint" className="underline">Impressum</a>.</p>
      </Section>
    </LegalLayout>
  );
}
